import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function simManagementTableReducer(state = initialState.simManagementTable, action) {
    switch (action.type) {
        case types.LOAD_SIM_MANAGEMENT_TABLE_SUCCESS:
            return action.simManagementTable;
        default:
            return state;
    }
}